module.exports = __webpack_public_path__ + "static/media/sidebar_bg.527198bd.png";